import { latestDramas } from '@/mocks/dramas';
import DramaCard from '@/components/base/DramaCard';

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-timer-flash-line text-primary-500 text-lg"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新更新</h2>
            </div>
            <p className="text-sm text-foreground-500">最新上线的热门剧集，追剧快人一步</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {latestDramas.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}